export default __webpack_public_path__ + "static/media/Revolugo.9731c6a9.png";